import { Waves } from "lucide-react";
import { CLIMATE_TOPICS, IMAGES, imgUrl } from "@/data/content";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function Climate() {
  return (
    <section id="climate" data-testid="climate-section" className="bg-sand py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 lg:grid-cols-12 lg:gap-12 lg:px-8">
        <Reveal className="relative order-2 lg:order-1 lg:col-span-6">
          <img
            src={imgUrl(IMAGES.reef, 1200)}
            alt="Clear Atlantic waters above a coral reef"
            loading="lazy"
            className="aspect-[16/11] w-full object-cover"
          />
          <div className="absolute -right-3 -top-3 -z-10 h-full w-full bg-ocean/10" aria-hidden="true" />
        </Reveal>
        <Reveal delay={0.12} className="order-1 lg:order-2 lg:col-span-6">
          <SectionHeading
            chapter="06"
            kicker="Climate, Health and Resilience"
            title="Shared Vulnerabilities, Practical Solutions"
            copy="Reporting on the risks Africa and the Caribbean face together — and the preparedness, science and cooperation that can reduce them."
          />
          <div className="mt-10 flex flex-wrap gap-3">
            {CLIMATE_TOPICS.map((t) => (
              <span
                key={t}
                data-testid={`climate-topic-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="flex items-center gap-2 border border-atlantic/15 bg-white px-4 py-2.5 text-xs font-semibold tracking-wide text-atlantic/80 transition-colors hover:border-ocean hover:text-ocean"
              >
                <Waves size={13} className="text-ocean" />
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
